import React from "react";
import TextField from "@mui/material/TextField";

interface InputCellProps {
  value?: string | number;
  onChange?: (value: any) => void;
  type?: string;
}

const InputCell: React.FC<InputCellProps> = ({
  value = "",
  onChange,
  type = "text",
}) => {
  return (
    <TextField
      value={value}
      onChange={(e) =>
        onChange &&
        onChange(type === "number" ? Number(e.target.value) : e.target.value)
      }
      type={type}
      fullWidth
      size="small"
    />
  );
};

export default InputCell;
